const Handlers = {
    name_changed({ name }, last_updated) { // eslint-disable-line camelcase
        return {
            name,
            last_updated
        };
    },
    description_changed({ description }, last_updated) { // eslint-disable-line camelcase
        return {
            description,
            last_updated
        };
    },
    location_changed({ longitude, latitude }, last_updated) { // eslint-disable-line camelcase
        return {
            location: {
                longitude,
                latitude
            },
            last_updated
        };
    },
    state_changed(properties, updated) {
        if (!properties.object_present) {
            properties.object_present = false;
        }
        return {
            state: {
                properties,
                updated
            }
        };
    }
};

const RECONNECTION_INTERVAL = 3000; // 3 seconds
const HEARTBEAT_INTERVAL = 600000; // 10 minutes
const SUBSCRIPTION_READY_DELAY = 200; // 200 ms

export default class ThingUpdatesSubscription {
    constructor(url, onMessageCallback) {
        this.url = url;
        this.onMessageCallback = onMessageCallback;

        this.isAlive = null;
        this.restartTimerId = null;
        this.heartbeatTimerId = null;
        this.statusTimerId = null;

        this.start = this.start.bind(this);
        this.up = this.up.bind(this);

        this.onError = this.onError.bind(this);
        this.onMessage = this.onMessage.bind(this);
        this.onHeartbeatTimeout = this.onHeartbeatTimeout.bind(this);

        this.start();
    }

    start() {
        this.evtSource = new EventSource(this.url());

        this.evtSource.onerror = this.onError;
        this.evtSource.onmessage = this.onMessage;

        this.scheduleUp();

        this.scheduleHeartbeatTimeout();
    }

    stop() {
        this.evtSource.close();

        clearTimeout(this.restartTimerId);
        clearTimeout(this.heartbeatTimerId);
        clearTimeout(this.statusTimerId);

        this.down();
    }

    up() {
        this.isAlive = true;
    }

    down() {
        this.isAlive = false;
    }

    scheduleStart() {
        clearTimeout(this.restartTimerId);
        this.restartTimerId = setTimeout(this.start, RECONNECTION_INTERVAL);
    }

    scheduleHeartbeatTimeout() {
        clearTimeout(this.heartbeatTimerId);
        this.heartbeatTimerId = setTimeout(this.onHeartbeatTimeout, HEARTBEAT_INTERVAL);
    }

    scheduleUp() {
        clearTimeout(this.statusTimerId);
        this.statusTimerId = setTimeout(this.up, SUBSCRIPTION_READY_DELAY);
    }

    onHeartbeatTimeout() {
        this.stop();
        this.start();
    }

    onError() {
        this.stop();
        this.scheduleStart();
    }

    onMessage(ev) {
        this.scheduleHeartbeatTimeout();

        const data = JSON.parse(ev.data);
        if (data && data.result) {
            const update = data.result;
            let patch = {};
            Object.keys(Handlers).forEach((section) => {
                if (section in update) {
                    patch = {
                        ...Handlers[section](update[section], update.timestamp)
                    };
                }
            });
            this.onMessageCallback(update.thing_id, patch);
        }
    }
}



// WEBPACK FOOTER //
// ./app/services/api/things/thing-subscriber.class.js